import * as React from "react";
import { app, authentication } from "@microsoft/teams-js";
import { RouteComponentProps } from "react-router-dom";
import { Text, Button, Image } from "@fluentui/react-northstar";

import './signin-page.scss'

const SignInPage: React.FunctionComponent<RouteComponentProps> = props => {
    function onSignIn() {
        app.initialize();
        authentication.authenticate({
            url: window.location.origin + "/signin-simple-start",
            successCallback: () => {
                console.log("Login succeeded!");
                window.location.href = "/list-serventias";
            },
            failureCallback: (reason) => {
                console.log("Login failed: " + reason);
                window.location.href = "/errorpage";
            }
        });
    }

    return (
        <div className="sign-in-content-container">
            <Text
                content={"Clique aqui para efetuar seu login."}
                size="medium"
            />
            <div className="space"></div>
            <Button content="Login" primary className="sign-in-button" onClick={onSignIn} />
        </div>
    );
};


export default SignInPage;